import React, { useState, useEffect } from 'react';
import api from '../api/client';
import './ChangesPopup.css';

const ChangesPopup = ({ isOpen, date, onClose }) => {
    const [changesData, setChangesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const convertToSQLDate = (dateStr) => {
        const [month, day, year] = dateStr.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    useEffect(() => {
        if (isOpen && date) {
            const fetchChanges = async () => {
                setLoading(true);
                try {
                    const sqlDate = convertToSQLDate(date);
                    const response = await api.get(`/api/seeds_changes/${sqlDate}`);
                    setChangesData(response.data);
                } catch (err) {
                    console.error('Error fetching changes:', err);
                    setError('Failed to load changes');
                } finally {
                    setLoading(false);
                }
            };
            fetchChanges();
        }
    }, [isOpen, date]);

    const formatWeight = (weight) => {
        return weight !== null && weight !== undefined ? Number(weight).toFixed(2) : '-';
    };

    const formatDate = (date) => {
        if (!date) return '-';
        const d = new Date(date);
        return `${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}/${d.getFullYear()}`;
    };

    const getChangedFields = (change) => {
        const fields = [];
        if (change.old_container !== change.new_container) {
            fields.push(`Container: <span class="old-value">${change.old_container || '-'}</span> / ${change.new_container || '-'}`);
        }
        if (change.old_lot !== change.new_lot) {
            fields.push(`Lot: <span class="old-value">${change.old_lot || '-'}</span> / ${change.new_lot || '-'}`);
        }
        if (change.old_weight !== change.new_weight) {
            fields.push(`Weight: <span class="old-value">${formatWeight(change.old_weight)}</span> / ${formatWeight(change.new_weight)}`);
        }
        if (change.old_germtestrate !== change.new_germtestrate) {
            fields.push(`Germ Rate: <span class="old-value">${change.old_germtestrate || '-'}</span> / ${change.new_germtestrate || '-'}`);
        }
        if (change.old_germtestdate !== change.new_germtestdate) {
            fields.push(`Germ Date: <span class="old-value">${formatDate(change.old_germtestdate)}</span> / ${formatDate(change.new_germtestdate)}`);
        }
        return fields.join('<br />');
    };

    if (!isOpen) return null;

    return (
        <div className="changes-popup">
            <div className="changes-popup-overlay" onClick={onClose}></div>
            <div className="changes-popup-content">
                <div className="changes-popup-header">
                    <h3>Changes on {date}</h3>
                    <button onClick={onClose}>Close</button>
                </div>
                {loading ? (
                    <p>Loading...</p>
                ) : error ? (
                    <p>{error}</p>
                ) : changesData.length === 0 ? (
                    <p>No changes on this date.</p>
                ) : (
                    <div className="changes-table-container">
                        <table className="changes-table">
                            <thead>
                                <tr>
                                    <th>Seeds Name</th>
                                    <th>Bag Number</th>
                                    <th>Changed Fields</th>
                                    <th>Confirmed By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {changesData.map((change, index) => (
                                    <tr key={index}>
                                        <td>{change.combinedSeedsName}</td>
                                        <td>{change.bagnumid}</td>
                                        <td dangerouslySetInnerHTML={{ __html: getChangedFields(change) }} />
                                        <td>{change.employeeName}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChangesPopup;